<script lang="ts">
	import { CopyButton } from '@repo/commons/components'
	import { copyToClipboard } from '@repo/commons/utils'
	import type { TableData } from '@repo/commons/models'
	import { truncateLineInNode } from '@repo/commons/utils'

	interface Props {
		row: TableData
		key: string
	}

	let { row, key }: Props = $props()

	const value = $derived(row[key] ?? '')

	const handleCopy = () => {
		copyToClipboard(String(value))
	}
</script>

<div class="id-cell">
	<span class="id-text" title={value}>{truncateLineInNode(value)}</span>
	<div class="copy-btn">
		<CopyButton onClick={handleCopy} iconSize="md" />
	</div>
</div>

<style>
	.id-cell {
		@apply flex items-center gap-1;
	}
	.id-text {
		@apply text-base text-[#606266] truncate;
	}
	.copy-btn {
		@apply flex-shrink-0;
	}
</style>
